import i18n from 'i18n'
import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"

import { OVERVIEW } from 'app/@common/constants'
import { monthNames } from 'app/@utils/dateLocale'

// Backend sends value='YYYYMM' + label='June 2026' (EN) and value='custom' + label='Custom date range' (EN).
// Localize the month name by the numeric value in the active language; fall back to the EN label split.
const localizedMonthYear = (value, label) => {
    if (typeof value === 'string' && /^\d{6}$/.test(value)) {
        const year = value.slice(0, 4)
        const monthIdx = parseInt(value.slice(4, 6), 10) - 1
        return { monthName: monthNames('long')[monthIdx], year }
    }
    const parts = (label || '').split(' ')
    return { monthName: parts[0] || label, year: parts[1] || '' }
}

const formatOptionLabel = (option, { context }) => {
    const { value, lastDate } = option
    const label = value === 'custom' ? i18n.t('common:excel.customDateRange') : option.label

    if (context === 'value' && value === 'custom') return label

    if (context === 'value') {
        const { monthName, year } = localizedMonthYear(value, label)
        return `${monthName}${year ? ` ${year}` : ''}`
    }

    if (value === 'custom') {
        const formattedLastDate = lastDate ?
            i18n.t('common:misc.upTo', { date: `${lastDate.slice(6, 8)}/${lastDate.slice(4, 6)}/${lastDate.slice(0, 4)}` }) :
            null

        return <div style={{ padding: '2px 0', lineHeight: 1.3 }}>
            <div style={{ fontWeight: 600, fontSize: '13px', color: '#1f2937' }}>{label}</div>
            {formattedLastDate && <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '3px' }}>{formattedLastDate}</div>}
        </div>
    }

    const { monthName, year } = localizedMonthYear(value, label)

    return <div style={{ padding: '2px 0', lineHeight: 1.3 }}>
        <div style={{ fontWeight: 600, fontSize: '13px', color: '#1f2937' }}>{monthName}</div>
        {year && <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '3px' }}>{year}</div>}
    </div>
}

export default function SelectMonth({...props}) {

    const myProps = {
        urlAjax: OVERVIEW.DATE_RANGE,
        icon: { icon: 'calendar' },
        firstSelect: true,
        formatOptionLabel,
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}